'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLocalStorage } from '@uidotdev/usehooks';
import { useGetFeatureFlag } from '@/lib/feature-flags/hooks/use-get-feature-flag';
import type { FeatureFlagVariant } from '@/lib/feature-flags/types';
const ONE_TAP_VARIANT_STORAGE_KEY = '__ab_test_google_one_tap_2026_q4_variant';
interface UseSignUpOneTapVariantReturn {
  isOneTapArm: boolean;
  variant: FeatureFlagVariant | undefined;
}

// Same shape as `usePasswordlessSignUpVariant`: PostHog wins once it has answered, and the cached value
// covers the gap before it does, so a returning visitor's first events on the screen already carry the
// arm. Fails closed: only an explicit `experiment` loads the prompt, so at 0% rollout nothing changes.
export function useSignUpOneTapVariant() {
  const $ = _c(8);
  const [storedVariant, setStoredVariant] = useLocalStorage(ONE_TAP_VARIANT_STORAGE_KEY, null);
  const posthogVariant = useGetFeatureFlag("ab_test_google_one_tap_2026_q4");
  const resolvedVariant = posthogVariant ?? storedVariant ?? undefined;
  const variant = resolvedVariant === "control" || resolvedVariant === "experiment" ? resolvedVariant : undefined;
  let t0;
  let t1;
  if ($[0] !== posthogVariant || $[1] !== setStoredVariant || $[2] !== storedVariant) {
    t0 = () => {
      if (posthogVariant === undefined || storedVariant === posthogVariant) {
        return;
      }
      setStoredVariant(posthogVariant);
    };
    t1 = [storedVariant, posthogVariant, setStoredVariant];
    $[0] = posthogVariant;
    $[1] = setStoredVariant;
    $[2] = storedVariant;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  const t2 = variant === "experiment";
  let t3;
  if ($[5] !== t2 || $[6] !== variant) {
    t3 = {
      isOneTapArm: t2,
      variant
    };
    $[5] = t2;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}